const appConst = {
	playerBaseUrl: 'https://play.qobuz.com',
	descriptionMaxLength: 500,
	albumCardDescMaxLength: 220,
	albumBlocDescMaxLength: 400,
	defaultSampleDuration: 45,
	CONFIG: {
		APP_ID: '214748364',
		API_URL: 'http://www.qobuz.com/api.json/0.2',
		ANDROID_STORE_URL: 'market://details?id=com.qobuz.music&hl=fr',
		IOS_STORE_URL: 'https://itunes.apple.com/fr/app/qobuz-music/id946429340?mt=8'
	},
	timeForGaplessPreload: 10,
	firstPlayLoad: 5,
	playLoadStep: 300,
	trackListLoadStep: 20,
	businessLayer: {
		code: {
			sessionExpired: 440,
			unauthorized: 401,
			badParameters: 422,
			timeout: 410
		}
	},
	trackQuality: {
		lls: 1,
		smr: 2
	},
	albumOderUrl: 'https://www.qobuz.com/album/order/',
	seeSubscribesUrl: 'https://www.qobuz.com/store-router/plans/music-streaming-subscription',
	focus: {
		layout: {
			imageFull: '[Focus] Image Full',
			title: '[Focus] Title',
			carousel: '[Focus] Carrousel Albums',
			text: '[Focus] Text Html',
			image: '[Focus] Image',
			doubleImages: '[Focus] Double Images',
			playlist: '[Focus] Playlist',
			album: '[Focus] Album',
			quote: '[Focus] Quote'
		}
	},
	mixFilter: ['Mix', 'Mixer', 'Mastering', 'Engineer']
}

export default appConst



// WEBPACK FOOTER //
// ./src/constant/appConst.js